import type { ParsedUrlQuery, ParsedUrlQueryInput } from 'querystring';
import type { OverrideValues } from '@/interfaces';

const fromUrlKey = <T>(urlKey: string, conversionObject: OverrideValues<T, string>): keyof T | undefined => {
    for (const filterKey in conversionObject) {
        if (conversionObject[filterKey] === urlKey) {
            return filterKey;
        }
    }
    return undefined;
};

export const toUrlKey = <T>(key: keyof T, conversionObject: OverrideValues<T, string>): string | undefined => conversionObject[key];

export const toUrlKeys = <T>(queryParams: ParsedUrlQueryInput, conversionObject: OverrideValues<T, string>): ParsedUrlQueryInput => {
    const result: ParsedUrlQueryInput = {};
    for (const filterKey in queryParams) {
        const urlKey = toUrlKey(filterKey as keyof T, conversionObject);
        if (urlKey) {
            result[urlKey] = queryParams[filterKey];
        }
    }
    return result;
};

export const fromUrlKeys = <T>(queryParams: ParsedUrlQuery, conversionObject: OverrideValues<T, string>): ParsedUrlQuery => {
    const result: ParsedUrlQuery = {};
    for (const urlKey in queryParams) {
        const filterKey = fromUrlKey(urlKey, conversionObject);
        if (filterKey) {
            result[filterKey as string] = queryParams[urlKey];
        }
    }
    return result;
};
